//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Fade } from '@mui/material';
import axios from '../../_utils/axios';
import ProfileTitleBar from './ProfileTitleBar';
import ProfileDetail from './ProfileDetail';
import { useToast } from '../_common/Toast';

const Profile = () => {
  const { id } = useParams();
  const history = useHistory();
  const { error } = useToast();
  const [profile, setProfile] = useState(null);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    axios
      .get(`/core/profile_templates/${id}/`)
      .then((res) => setProfile(res.data?.data))
      .catch(() => {
        setProfile(null);
        error('There was a problem loading the profile.');
        history.replace('/not-found');
      });
  }, [id]);

  const saveProfile = async (data) => {
    const res = await axios.post(`/core/profile_templates/${profile.id}/`, data);
    const id = res.data?.data?.id;
    history.push(`/profiles/${id}`);
    setProfile(res.data?.data);
    setEditing(false);
  };

  return (
    <Fade in timeout={600}>
      <div>
        <ProfileTitleBar name={profile?.name} setEditing={setEditing} />

        {profile && <ProfileDetail profile={profile} editing={editing} setEditing={setEditing} saveProfile={saveProfile} />}
      </div>
    </Fade>
  );
};

export default Profile;
